export class WorkType {
  static get RETURN () {
    return 1
  }
  static get REMOVE () {
    return 2
  }

  static getFormWorkTypeName (Order) {
    let name = ''
    switch (Order) {
      case 1:
        name = '拆'
        break
      case 2:
        name = '裝'
        break
    }
    return name
  }
}
